import { render } from "./BookSeat.vue?vue&type=template&id=47d76b2e&scoped=true"
import script from "./BookSeat.vue?vue&type=script&lang=js"
export * from "./BookSeat.vue?vue&type=script&lang=js"

import "./BookSeat.vue?vue&type=style&index=0&id=47d76b2e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-47d76b2e"

export default script